export type ScreeningSuggestion = {
	title: string;
	content: string;
};

export type ScreeningConclusionCopy = {
	meaning: string;
	items: ScreeningSuggestion[];
};

const empty = (): ScreeningConclusionCopy => ({ meaning: '', items: [] });

const textOf = (value: unknown) =>
	typeof value === 'string' ? value.trim() : '';

export const conclusionLabel = (value: unknown) => {
	if (!value) return '';
	if (typeof value === 'string') return value;
	if (typeof value === 'object') {
		const record = value as Record<string, unknown>;
		return textOf(record.label || record.name || record.title);
	}
	return '';
};

export const readConclusionCopy = (source: unknown): ScreeningConclusionCopy => {
	if (!source || typeof source !== 'object') return empty();
	const conclusion = (source as Record<string, unknown>).conclusion;
	if (!conclusion || typeof conclusion !== 'object') return empty();
	const record = conclusion as Record<string, unknown>;
	const meaning = textOf(record.meaning);
	const suggestions = Array.isArray(record.suggestions) ? record.suggestions : [];
	const items = suggestions
		.map((item) => {
			if (!item || typeof item !== 'object') return null;
			const entry = item as Record<string, unknown>;
			const title = textOf(entry.title);
			const content = textOf(entry.content);
			if (!title && !content) return null;
			return { title, content };
		})
		.filter((item): item is ScreeningSuggestion => !!item);
	return { meaning, items };
};

const linkify = (input: string) =>
	input.replace(
		/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
		'<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>'
	);

export const toConclusionHtml = (value: string) => {
	const text = value || '';
	if (!text.trim()) return '';
	if (/<[a-z][\s\S]*>/i.test(text)) return linkify(text);
	return linkify(
		text
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/\n/g, '<br>')
	);
};
